var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"padded-space limits-and-collateral-view"},[_c('h2',[_vm._v("Trading Limits and Collateral")]),_c(_setup.LimitsAndCollateralManagement)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }